<template>
  <v-layout>
    <v-container fill-height v-if="group">
      <v-row justify="center" align="center">
        <v-card width="800">
          <div style="float:right;" class="pa-4">
            <v-btn
              class="red darken-2"
              style="color:white;"
              @click="removeGroupDialog = true"
              >delete</v-btn
            >
          </div>

          <v-card-title
            ><v-icon class="mr-2" icon>mdi-cog</v-icon> Settings</v-card-title
          >
          <v-divider></v-divider>

          <v-card-text style="color: black;">
            <v-form lazy v-model="valid">
              <div class="mt-5">
                <v-text-field
                  label="Group name"
                  v-model="groupName"
                ></v-text-field>
              </div>

              <!-- Mailto -->
              <div>
                <v-checkbox
                  v-model="mailto"
                  name="mailto"
                  color="primary"
                  label="Open Mailto Links"
                ></v-checkbox>
              </div>

              <div>
                <v-text-field
                  v-model="webAccessInstance"
                  label="Web Access Instance"
                ></v-text-field>
              </div>

              <!-- Bcc -->
              <div>
                <v-checkbox
                  v-model="bcc"
                  color="primary"
                  label="Bcc"
                ></v-checkbox>
              </div>

              <!-- Lock settings -->
              <div>
                <v-checkbox
                  v-model="locked"
                  color="primary"
                  label="Lock settings"
                ></v-checkbox>
              </div>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="changeSettings">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-row>

      <!-- Members card -->
      <v-row justify="center" align="center">
        <v-card width="800" class="mt-5">
          <div class="pa-3" style="float:right;">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" icon large
                  ><v-icon @click="addGoogleMemberDialog = true" icon
                    >mdi-account-plus</v-icon
                  ></v-btn
                >
              </template>
              <span>Add a single member</span>
            </v-tooltip>
          </div>

          <v-card-title class="text-right"
            ><v-icon class="mr-2" icon>mdi-account-multiple</v-icon>
            Members</v-card-title
          >

          <v-divider></v-divider>

          <v-card-text>
            <v-list>
              <v-list-item v-for="member in group.members" :key="member.id">
                <v-list-item-icon>
                  <v-icon v-if="member.type === 'user'">mdi-account</v-icon>
                  <v-icon v-else-if="member.type === 'group'"
                    >mdi-account-box</v-icon
                  >
                </v-list-item-icon>

                <v-list-item-title
                  >{{ member.name }}
                  <v-list-item-subtitle>{{
                    member.email
                  }}</v-list-item-subtitle>
                </v-list-item-title>

                <v-list-item-action>
                  <v-btn
                    icon
                    @click="removeMember(member.id)"
                    :loading="removeMemberLoading[member.id]"
                    :disabled="
                      removeMemberLoading[member.id] ||
                        group.members.length === 0 ||
                        member.id === userId
                    "
                    ><v-icon>mdi-account-remove</v-icon></v-btn
                  >
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>

    <v-dialog persistent v-model="addGoogleMemberDialog" width="500">
      <v-card>
        <v-card-title>Add member</v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-autocomplete
            :search-input.sync="userSearch"
            :loading="googleUserSearchLoading"
            label="User"
            hide-no-data
            :items="googleUsers"
            item-text="primaryEmail"
            item-value="id"
          ></v-autocomplete>

          <v-select
            v-model="role"
            label="Role"
            :items="['ADMIN', 'USER']"
          ></v-select>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            @click="addGoogleMemberDialog = false"
            :disabled="addGoogleMemberLoading"
            >close</v-btn
          >
          <v-btn
            color="primary"
            @click="addMember"
            :loading="addGoogleMemberLoading"
            :disabled="addGoogleMemberLoading"
            >Add</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="addGoogleGroupDialog" width="500">
      <v-card>
        <v-card-title>Add google group</v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-autocomplete
            :search-input.sync="groupSearch"
            :loading="googleGroupSearchLoading"
            label="Group"
            hide-no-data
            :items="googleGroups"
            item-text="email"
            item-value="id"
          ></v-autocomplete>

          <v-select
            v-model="role"
            label="Role"
            :items="['ADMIN', 'USER']"
          ></v-select>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            @click="addGoogleGroupDialog = false"
            :disabled="addGoogleGroupLoading"
            >close</v-btn
          >
          <v-btn
            color="primary"
            @click="addGroup"
            :loading="addGoogleGroupLoading"
            :disabled="addGoogleGroupLoading"
            >Add</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="removeGroupDialog" width="500" v-if="group">
      <v-card>
        <v-card-title>Remove group</v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <p class="mt-5">
            You are about to remove <strong>{{ group.name }}</strong
            >. Removing <strong>{{ group.name }}</strong> will delete it
            permanently and you will have to recreate it again. All of the
            settings will have to be reconfigured and members will have to be
            added again. Are you sure about this?
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="removeGroupDialog = false">close</v-btn>

          <v-btn
            color="red darken-2"
            @click="deleteGroup"
            :loading="deleteGroupLoading"
            :disabled="deleteGroupLoading"
            >remove</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import google from "@/api/google";
import { mapGetters } from "vuex";
export default {
  data: () => ({
    valid: false,

    addGoogleMemberDialog: false,
    addGoogleGroupDialog: false,
    removeGroupDialog: false,

    groupName: null,
    bcc: false,
    mailto: false,
    locked: false,
    webAccessInstance: null,

    userSearch: null,
    groupSearch: null,

    role: "ADMIN",

    googleGroups: [],
    googleUsers: [],

    addGoogleMemberLoading: false,
    addGoogleGroupLoading: false,
    removeMemberLoading: {},
    changeSettingsLoading: false,
    deleteGroupLoading: false,
    googleGroupSearchLoading: false,
    googleUserSearchLoading: false,
  }),

  computed: {
    ...mapGetters({
      getGroupById: "group/getGroupById",
      signedIn: "user/signedIn",
      userToken: "user/token",
      userId: "google/userId",
    }),

    group() {
      return this.getGroupById(this.$route.params.id);
    },
  },

  methods: {
    async fetchDebouncedGroups() {
      this.googleGroupSearchLoading = true;
      clearTimeout(this._timerId);
      this._timerId = setTimeout(async () => {
        await google
          .searchGroups(this.userToken, this.groupSearch.trim())
          .then((r) => {
            const { groups } = r;
            this.googleGroups = groups;
          })
          .finally(() => {
            this.googleGroupSearchLoading = false;
          });
      }, 2000);
    },

    async fetchDebouncedUsers() {
      this.googleUserSearchLoading = true;
      clearTimeout(this._timerId);
      this._timerId = setTimeout(async () => {
        await google
          .searchUsers(this.userToken, this.userSearch.trim())
          .then((r) => {
            const { users } = r;
            this.googleUsers = users;
          })
          .finally(() => {
            this.googleUserSearchLoading = false;
          });
      }, 2000);
    },

    changeSettings() {
      this.changeSettingsLoading = true;
      this.$store
        .dispatch("group/changeSettings", {
          groupId: this.group.id,
          payload: {
            name: this.groupName,
            bcc: this.bcc,
            mailto: this.mailto,
            web_access_instance: this.webAccessInstance,
            is_locked: this.locked,
          },
        })
        .catch((e) => {
          this.$store.dispatch("error/handle", e);
        })
        .finally(() => {
          this.changeSettingsLoading = false;
        });
    },

    deleteGroup() {
      this.deleteGroupLoading = true;
      this.$store
        .dispatch("group/delete", { groupId: this.group.id })
        .catch((e) => {
          this.$store.dispatch("error/handle", e);
        })
        .finally(() => {
          this.deleteGroupLoading = false;
          this.$router.push({ name: "groups" });
        });
    },

    addMember() {
      this.addGoogleMemberLoading = true;

      this.$store
        .dispatch("group/addMember", {
          groupId: this.group.id,
          payload: { email: this.userSearch, role: this.role },
        })
        .catch((e) => {
          this.$store.dispatch("error/handle", e);
        })
        .finally(() => {
          this.addGoogleMemberLoading = false;
          this.addGoogleMemberDialog = false;
        });
    },

    addGroup() {
      this.addGoogleGroupLoading = true;

      this.$store
        .dispatch("group/addMember", {
          groupId: this.group.id,
          isGroup: 1,
          payload: { email: this.groupSearch, role: this.role },
        })
        .catch((e) => {
          this.$store.dispatch("error/handle", e);
        })
        .finally(() => {
          this.addGoogleGroupLoading = false;
          this.addGoogleGroupDialog = false;
        });
    },

    removeMember(memberId) {
      this.$set(this.removeMemberLoading, memberId, true);

      this.$store
        .dispatch("group/removeMember", {
          groupId: this.group.id,
          memberId,
        })
        .catch((e) => {
          this.$store.dispatch("error/handle", e);
        })
        .finally(() => {
          this.$set(this.removeMemberLoading, memberId, false);
        });
    },
  },

  watch: {
    async signedIn(v) {
      if (v) {
        try {
          await this.$store.dispatch("group/fetch");
        } catch (e) {
          this.$store.dispatch("error/handle", e);
        }
      }
    },

    group(v) {
      if (v) {
        this.$route.meta.title = v.name;

        this.groupName = v.name;
        this.bcc = v.settings.bcc;
        this.locked = v.settings.is_locked;
        this.mailto = v.settings.mailto;
        this.webAccessInstance = v.settings.web_access_instance;
      }
    },

    userSearch(v) {
      if (!v) {
        this.googleUsers = [];

        return;
      }
      if (v) {
        if (this.googleUsers.length === 0) {
          this.fetchDebouncedUsers();
        }
      }
    },

    groupSearch(v) {
      if (!v) {
        this.googleGroups = [];

        return;
      }
      if (v) {
        if (this.googleGroups.length === 0) {
          this.fetchDebouncedGroups();
        }
      }
    },
  },

  async mounted() {
    if (this.signedIn) {
      try {
        await this.$store.dispatch("group/fetch");
      } catch (e) {
        this.$store.dispatch("error/handle", e);
      }
    }

    if (this.group) {
      this.$route.meta.title = this.group.name;
    }
  },
};
</script>
